export default __webpack_public_path__ + "static/media/mall-banner-id.e9bc757f.jpg";